import { Box, Container, Grid, Paper, Typography } from '@mui/material';
import { Award, UserCheck, Building, GraduationCap, Sparkles, HeartHandshake, CheckCircle } from 'lucide-react';

const ICON_MAP = {
  Award,
  UserCheck,
  Building,
  GraduationCap,
  Sparkles,
  HeartHandshake,
};

export function WhyChooseUs({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const whyList = Array.isArray(data.why_choose_us) ? data.why_choose_us : [];

  if (whyList.length === 0) return null;

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#ffffff' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 7 }}>
          <Box sx={{ display: 'inline-block', px: 2, py: 0.5, borderRadius: 4, backgroundColor: `${primaryColor}15`, color: primaryColor, mb: 1.5 }}>
            <Typography variant="caption" fontWeight={700} letterSpacing="0.05em">
              OUR ADVANTAGE
            </Typography>
          </Box>
          <Typography variant="h2" fontWeight={800} color="#0f172a" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1 }}>
            Why Choose {data.school_name || 'Our School'}?
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Providing holistic education that empowers students to excel academically and ethically.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {whyList.map((item, index) => {
            const isString = typeof item === 'string';
            const title = isString ? item : item.title;
            const description = isString ? '' : item.description;
            const IconComp = (!isString && item.icon && ICON_MAP[item.icon]) ? ICON_MAP[item.icon] : CheckCircle;

            return (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3.5,
                    height: '100%',
                    borderRadius: 4,
                    backgroundColor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: '#ffffff',
                      boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
                      borderColor: primaryColor,
                    },
                  }}
                >
                  <Box>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 2.5,
                        backgroundColor: `${primaryColor}15`,
                        color: primaryColor,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2,
                      }}
                    >
                      <IconComp size={24} />
                    </Box>
                    <Typography variant="h6" fontWeight={800} color="#0f172a" sx={{ mb: 1 }}>
                      {title}
                    </Typography>
                    {description && (
                      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                        {description}
                      </Typography>
                    )}
                  </Box>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}

export default WhyChooseUs;
